<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md6>
        <material-card>
          <v-card-text class="text-center">
            <v-img :src="image" height="100%"></v-img>
            <div v-if="isUnauthorizedError">
              <h3>Sorry, this user is not authorized</h3>
              <p class="category mb-3">
                {{error.error_description}}
              </p>
            </div>
            <div v-else>
              <h3>Something went wrong!</h3>
              <p class="category mb-3">
                Sorry about that, if the problem persists please send us an email including the details below at support@jig.space and we'll get it fixed right away!
              </p>
            </div>
            <v-btn color="primary" @click="logout">Log Out</v-btn>
            <p></p>
            <v-expansion-panels v-if="error">
              <v-expansion-panel>
                <v-expansion-panel-header>Show details...</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>{{this.error}}</v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script lang="js">
import { mapState } from 'vuex';
import { TenantHelpers } from '@/utils/tenant-helpers';

export default {
  data() {
    return {
      error: '',
      image: './img/GlitchedLogo_BiColor2_sml.png',
    };
  },
  mounted() {
    const hash = window.location.hash;
    if (hash) {
      this.error = this.parseQuery(hash);
    }
  },
  computed: {
    ...mapState('app', ['myTenant', 'myTenants', 'tenantUserCount']),
    isUnauthorizedError() {
      return (this.error && this.error.error === "unauthorized")
    },
    isErrorFromAuth0() {
      return (this.error && this.error.state !== undefined)
    },
  },
  methods: {
    parseQuery(queryString) {
      const query = {};
      const pairs = ((queryString[0] === '?' || queryString[0] === '#') ?
        queryString.substr(1) : queryString).split('&');
      for (const pair of pairs) {
        const parts = pair.split('=');
        query[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1] || '');
      }
      return query;
    },
    async logout() {
      if (this.myTenant && this.myTenant.ID !== TenantHelpers.InvalidTenantID) {
        await this.$auth.segmentIdentityTracking(this.myTenants, this.myTenant, { TenantUserCount: this.tenantUserCount })
      }
      this.$auth.logOut();
      this.$router.push({ path: '/' });
    },
  },
};
</script>
